/* *************************************************************** *
 * THIS IS AN AUTO GENERATED FILE. PLEASE DO NOT EDIT IT DIRECTLY.
 *
 * If you want to change this Icon component , it is generated
 * from the `iconTamplate.js` file the parent directory.
 * *************************************************************** */
/* eslint-disable */
import React from 'react';
import { useFela, } from 'react-fela';
import iconStyle from '../iconStyle';
import { iconPropTypes, iconDefaultProps, } from '../iconPropTypes';

export default function IconTelegram({ size, fill, color, attrs, miscStyles, ...props }) {
  const className = useFela({ size, fill, color, miscStyles, }).css(iconStyle);

  return (
    <svg width="1em" height="1em" viewBox="0 0 256 256" className={className} {...props} {...attrs} data-test="IconTelegram">  <path fillRule="evenodd" clipRule="evenodd" fill="currentColor" d="M233.994 39.221a7.235 7.235 0 00-7.206-1.267C188.877 51.999 72.125 95.847 24.404 113.521c-3.029 1.122-5 4.036-4.9 7.231.108 3.204 2.26 5.982 5.362 6.914 21.401 6.407 49.493 15.322 49.493 15.322s13.128 39.684 19.973 59.866c.859 2.534 2.839 4.525 5.452 5.213a7.828 7.828 0 007.333-1.873l27.992-26.453s32.296 23.702 50.614 36.761c2.911 2.063 6.664 2.579 10.009 1.312a10.498 10.498 0 006.546-7.602c7.857-36.96 26.916-130.51 34.068-164.131a7.075 7.075 0 00-2.352-6.86zm-37.178 34.001c-33.435 30.182-92.087 83.133-92.087 83.133l-3.372 31.738-15.181-50.119S154.963 94 193.715 69.23c1.112-.706 2.595-.462 3.4.579a2.516 2.516 0 01-.299 3.413z" /></svg>
  );
}

IconTelegram.propTypes = iconPropTypes;
IconTelegram.defaultProps = iconDefaultProps;
